import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../../shared/services/logging';
import { EfaactDataService } from '../../../efaact.data-service';
import { InvoiceSessionType } from './invoice-session-type.model';

export const entityName = 'InvoiceSessionType';
@Injectable({ providedIn: 'root' })
export class InvoiceSessionTypeDataService extends EfaactDataService<InvoiceSessionType> {
    mapItems(item: InvoiceSessionType): InvoiceSessionType {
        return item;
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
